import routesUtils from '@/utils/routes';

export function beforeEnterEspecialista(to, _from, next) {
    const usuarioLogado = JSON.parse(
        sessionStorage.getItem('dadosUsuario')
    );

    routesUtils.userHasRequiredRoles(
        usuarioLogado,
        to.meta.roles
    )
        ? next()
        : next('/');
}
